<template>
  <div id="app">
    <a-watermark v-if="showWatermark" :content="['上海卓厉软件工作室','zolysoft']">
      <router-view />
    </a-watermark>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>
<script>

export default {
  name: 'App',
  components: {

  },
  data() {
    return {
      showWatermark: false
    }
  },
  // 监听pinia
  watch: {
      '$store.state.showWatermark': {
        handler(val) {
          this.showWatermark = val
        },
        immediate: true
      }
  },

  mounted() {


  },
  methods: {

  }
}
</script>

<style lang="scss">
/* 在你的全局样式文件中 */
:root {
  --border-radius-none: 10px;  /* 将默认的直角改为4px圆角 */
  --border-radius-small: 16px;
  --border-radius-medium: 18px;
  --border-radius-large: 22px;
}
</style>

<style>
/* 全局基础样式 */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden; /* 防止整个页面出现滚动条 */
}

#app {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/**{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: var(--color-text-2);
}*/

.ground_glass{
  /* 优化的毛玻璃效果，但降低模糊强度 */
  backdrop-filter: blur(8px) saturate(120%);
  -webkit-backdrop-filter: blur(8px) saturate(120%);
  background-color: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.p20{
  padding: 20px;
}

.card_section{
  margin-top: 40px;
  padding: 20px;
  /* 优化的毛玻璃效果 */
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(6px) saturate(110%);
  -webkit-backdrop-filter: blur(6px) saturate(110%);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.arco-table-tr.arco-table-tr-checked{
  background-color: rgba(90, 197, 76, 0.8);
}
</style>
